var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item_div",style:({'width':(1/_vm.item_num)*(100-_vm.item_num*2)+'%'})},[_c('el-image',{staticStyle:{"width":"100%","height":"20vh"},attrs:{"src":_vm.image_url,"fit":"cover"}}),_vm._v(" "),_c('div',{staticClass:"font_div"},[_c('p',{staticClass:"content_div"},[_vm._v("\n      "+_vm._s(_vm.content_txt)+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb0b0eba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list_item_video.vue
// module id = YgTs
// module chunks = 1